import { useCallback } from 'react';
import { useAppSelector } from '@/features';
import { type Action, type ActionByCategory, type Topic } from '@/types/swagger';

export const useActionUtils = () => {
  const categories = useAppSelector((state) => state.notifications.notificationActions);

  const getTreeFromAction = useCallback(
    (actionCode?: string) => {
      let result: {
        category: ActionByCategory | null;
        topic: Topic | null;
        action: Action | null;
      } = { category: null, topic: null, action: null };
      categories.forEach((category) =>
        category.topics.forEach((topic) =>
          topic.actions.forEach((action) => {
            if (action.action_code === actionCode) {
              result = { category, topic, action };
            }
          })
        )
      );
      return result;
    },
    [categories]
  );

  const getActionPath = useCallback(
    (actionCode: string) => {
      const { category, topic, action } = getTreeFromAction(actionCode);
      return `${category?.category_name}/${topic?.topic_name}/${action?.action_name}`;
    },
    [getTreeFromAction]
  );

  return { getActionPath, getTreeFromAction };
};
